import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SharedModule } from '@shared/shared.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { AllOrdersComponent } from './all-orders/all-orders.component';
import { OrderOptionsComponent } from './order-options/order-options.component';
import { OverviewComponent } from './overview.component';

@NgModule({
  imports: [CommonModule, ComponentsModule, SharedModule, NgxDatatableModule, NgxSliderModule, AccordionModule.forRoot(),
  ],
  declarations: [OverviewComponent, OrderOptionsComponent, AllOrdersComponent]
})
export class OverviewModule { }

